import BugsnagPerformance from '@bugsnag/browser-performance';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import React from 'react';

Bugsnag.start({
    apiKey: '48ab207de491f9d905100580f8f5b515',
    plugins: [new BugsnagPluginReact()],
    releaseStage: process.env.NODE_ENV,
    appVersion: '1.0.0',
    onError: (event) => {
        event.addMetadata('userContext', {
            browser: window.navigator.userAgent,
        });
    }
});

BugsnagPerformance.start({ apiKey: '48ab207de491f9d905100580f8f5b515' })

export const bugsnagClient = Bugsnag;

export const ErrorBoundary = Bugsnag.getPlugin('react')?.createErrorBoundary(React);
